import React from "react";
import PropTypes from "prop-types";
import { useQuery } from "react-apollo";

import { Field, Control, Label, Select, Icon } from "rbx";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { ALL_USERS_QUERY } from "../../graphql/Users/Users.graphql";

function UserSelect({
  value,
  label,
  size,
  name,
  icon,
  onChange,
  disabled = false
}) {
  const { data, loading, error } = useQuery(ALL_USERS_QUERY);

  return (
    <Field>
      <Label size={size}>{label}</Label>
      <Control iconLeft size={size}>
        <Select.Container
          fullwidth
          color={error ? "danger" : ""}
          size={size}
          state={loading || !data ? "loading" : undefined}
        >
          <Select
            disabled={disabled}
            name={name}
            value={value}
            onChange={onChange}
          >
            <Select.Option value="">{label}</Select.Option>
            {!loading &&
              data.Users.map((user, i) => (
                <Select.Option key={`user-select-${i}`} value={user.RecId}>
                  {`${user.FirstName} ${user.LastName}`}
                </Select.Option>
              ))}
          </Select>
        </Select.Container>
        {icon && (
          <Icon align="left" size={size}>
            <FontAwesomeIcon icon={icon} />
          </Icon>
        )}
      </Control>
    </Field>
  );
}

UserSelect.propTypes = {
  value: PropTypes.string,
  name: PropTypes.string,
  label: PropTypes.string,
  size: PropTypes.string,
  icon: PropTypes.string,
  onChange: PropTypes.func,
  disabled: PropTypes.bool
};

UserSelect.defaultProps = {
  icon: "user"
};
export default UserSelect;
